export default "__VITE_ASSET__CZsHPNhp__"